module.exports = __webpack_public_path__ + "7d6c33d153da2b761e4b82cc93ed25f1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-6.png
// module id = 3141
// module chunks = 0